import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../theme/colors';

export const useEntityHistoryGroupStyles = makeStyles({
  wrapper: {
    position: 'relative',
    paddingBottom: '16px'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 0',
    marginBottom: '4px'
  },
  operationLabel: {
    fontSize: '13px',
    fontWeight: 600,
    color: Colors.darkGray,
    textTransform: 'uppercase'
  },
  actor: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  actorIcon: {
    color: Colors.darkGray,
    fontSize: '18px'
  },
  actorName: {
    fontSize: '13px',
    fontWeight: 700,
    color: 'black'
  },
  events: {
    paddingLeft: 0
  },
  divider: {
    marginTop: '24px',
    marginLeft: '-2rem',
    marginRight: '-2rem',
    borderBottom: `1px dashed ${Colors.midLightGray}`
  }
});
